import { RouteConfig } from 'vue-router'

const routes: RouteConfig[] = [
    {
        path: '/public/confirm-activity',
        component: () => import('@/views/public/ConfirmActivity.vue')
    },
]

export default routes;